import React, { useEffect, useRef, useState } from "react"
import {
  Card,
  Radio,
  Typography,
  Row,
  Col,
  Button,
  Divider,
  Tag,
  message,
} from "antd"
import {
  ShoppingCartOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons"
import "./style.css"
import MainLayout from "../../../../components/Layouts/index"
import { useNavigate, useParams } from "react-router-dom"
import AffiliateService from "src/services/AffiliateService"
import { identity } from "lodash"
import ROUTER from "src/router"

const { Title, Text } = Typography

export default function SimDetailPage() {
  const [simType, setSimType] = useState("esim")
  const [selectedPlan, setSelectedPlan] = useState(null)
  const { id } = useParams()
  const [simDetail, setSimDetail] = useState(null)
  const [scrollIndex, setScrollIndex] = useState(0)
  const [selectedDuration, setSelectedDuration] = useState(1)
  const [loading, setLoading] = useState(false)
  const carouselRef = useRef(null)
  const navigate = useNavigate()

  const scrollToIndex = index => {
    const container = carouselRef.current
    const card = container.children[index]
    if (card) {
      card.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      })
    }
  }
  const handleSelectPlan = (plan, index) => {
    if (selectedPlan?.ID === plan.ID) {
      setSelectedPlan(null)
    } else {
      setSelectedPlan(plan)
      setScrollIndex(index)
      scrollToIndex(index)
    }
  }
  useEffect(() => {
    const fetchSimDetail = async () => {
      try {
        const response = await AffiliateService.detailSimAffiliate(id)
        setSimDetail(response.success)
      } catch (error) {
        console.error("Lỗi khi lấy chi tiết SIM:", error)
        message.error("Không thể lấy thông tin SIM")
      }
    }

    if (id) {
      fetchSimDetail()
    }
  }, [id])
  const handleBuySim = async () => {
    // if (!selectedPlan) {
    //   return message.warning("Vui lòng chọn gói cước trước khi thanh toán!")
    // }
    setLoading(true)
    // try {
    //   const response = await AffiliateService.buySimAffiliate(id)

    //   // Kiểm tra dữ liệu thực tế trả về
    //   if (response.status === 200) {
    //     message.success(response.data.message || "Mua SIM thành công!")
    //   } else {
    //     message.error(response.data.message || "Mua SIM thất bại!")
    //   }
    // } catch (error) {
    //   console.error("Lỗi mua SIM:", error)

    //   if (error.response) {
    //     // Trường hợp lỗi có phản hồi từ server
    //     message.error(
    //       error.response.data.message || "Đã xảy ra lỗi từ máy chủ.",
    //     )
    //   } else {
    //     // Lỗi mạng hoặc lỗi khác
    //     message.error("Đã xảy ra lỗi, vui lòng thử lại.")
    //   }
    // }
    try {
      const response = await AffiliateService.buySimAffiliate(id)
      message.success(response.data?.message || "Mua SIM thành công!")
      navigate(ROUTER.SALES_BUY_SIM)
    } catch (error) {
      console.error("Lỗi mua SIM:", error)
      message.error(error?.response?.data?.message || "Mua SIM thất bại!")
    } finally {
      setLoading(false)
    }
  }
  const plans = [
    {
      ...simDetail?.package,
    },
    // {
    //   code: "MAY79",
    //   dataPerDay: "3GB",
    //   totalData: "90GB/tháng",
    //   price: 79000,
    //   note: "Gói cước tự động gia hạn\nHủy: soạn HUYGH MAY79 gửi 8968",
    // },

    // {
    //   code: "MAY199",
    //   dataPerDay: "5GB",
    //   totalData: "150GB/tháng",
    //   price: 99000,
    //   note: "Gọi nội mạng miễn phí (10 phút/lần, tối đa 500 phút)",
    // },
    // {
    //   code: "MAY299",
    //   dataPerDay: "5GB",
    //   totalData: "150GB/tháng",
    //   price: 99000,
    //   note: "Gọi nội mạng miễn phí (10 phút/lần, tối đa 500 phút)",
    // },
    // {
    //   code: "3MAY99",
    //   dataPerDay: "5GB",
    //   totalData: "150GB/tháng",
    //   price: 99000,
    //   note: "Gọi nội mạng miễn phí (10 phút/lần, tối đa 500 phút)",
    // },
    // {
    //   code: "5MAY99",
    //   dataPerDay: "5GB",
    //   totalData: "150GB/tháng",
    //   price: 99000,
    //   note: "Gọi nội mạng miễn phí (10 phút/lần, tối đa 500 phút)",
    // },
  ]

  console.log(id, "id")
  const unitPrice = 0
  const simPrice = Number(simDetail?.sale_price) || 0
  const total = simPrice + (selectedPlan?.price || 0) * selectedDuration

  return (
    <MainLayout>
      <div
        className="fade-in-up"
        style={{
          maxWidth: 1200,
          margin: "auto",
          padding: 20,
          height: "calc(100vh - 80px)",
          overflowY: "auto",
        }}
      >
        <Card bordered={false}>
          <Title level={3}>Số thuê bao bạn lựa chọn là</Title>
          <Title level={1}>{simDetail?.phone_number || "Đang tải..."}</Title>
          {/* <Text type="secondary">
            Cam kết tiêu dùng tối thiểu 490.000đ/tháng trong 12 tháng
          </Text> */}
          <Divider />

          <Title level={4}>1. Chọn loại SIM</Title>
          <Radio.Group
            onChange={e => setSimType(e.target.value)}
            value={simType}
            style={{ display: "flex", gap: 40 }}
          >
            {/* <Radio value="physical">
              <Text strong>SIM vật lý</Text>
              <br />
              <Text type="secondary">Là thẻ SIM nhựa được lắp vào máy</Text>
            </Radio> */}
            <Radio value="esim">
              <Text strong>eSIM</Text>
              <br />
              <Text type="secondary">
                Gửi qua email, chỉ dùng cho máy hỗ trợ eSIM
              </Text>
            </Radio>
          </Radio.Group>

          <Divider />
          {simDetail?.package && (
            <>
              <Title level={4}>2. Chọn gói cước</Title>
              <Text>Vui lòng chọn chu kỳ gói cước:</Text>
              <br />
              <div className="plan-buttons">
                {[1].map(month => (
                  <Button
                    key={month}
                    type={selectedDuration === month ? "primary" : "default"}
                    onClick={() => setSelectedDuration(month)}
                    style={{ margin: "10px 10px 10px 0" }}
                  >
                    {month} tháng
                  </Button>
                ))}
              </div>

              <div className="carousel-wrapper">
                <Button
                  icon={<LeftOutlined />}
                  onClick={() => {
                    const newIndex = Math.max(0, scrollIndex - 1)
                    setScrollIndex(newIndex)
                    scrollToIndex(newIndex)
                  }}
                  disabled={scrollIndex === 0}
                />

                <div className="carousel-container" ref={carouselRef}>
                  {plans.map(
                    (plan, index) => (
                      console.log(plan, "plan"),
                      (
                        <div
                          className={`carousel-card ${
                            selectedPlan?.ID === plan.ID ? "selected" : ""
                          }`}
                          key={plan.ID || plan.name}
                          onClick={() => handleSelectPlan(plan, index)}
                        >
                          {/* Nút radio tròn */}
                          <Radio
                            checked={selectedPlan?.ID === plan.ID}
                            onClick={e => {
                              e.stopPropagation() // Ngăn sự kiện lan ra div ngoài
                              if (selectedPlan?.ID === plan.ID) {
                                setSelectedPlan(null) // Bỏ chọn nếu click lại
                              } else {
                                handleSelectPlan(plan, index) // Chọn mới
                              }
                            }}
                            className="plan-radio"
                          />

                          <Card title={plan.name} hoverable bordered={false}>
                            <br />
                            <Tag color="red">
                              {(Number(plan.data_quantity) / 30).toFixed(2)}{" "}
                              GB/NGÀY
                            </Tag>
                            <br />
                            {plan.data_quantity} GB/tháng
                            <br />
                            {plan.package_type}
                            <Divider />
                            <Text strong>
                              {Number(plan.price).toLocaleString()}đ
                            </Text>
                            /tháng
                          </Card>
                        </div>
                      )
                    ),
                  )}
                </div>

                <Button
                  icon={<RightOutlined />}
                  onClick={() => {
                    const newIndex = Math.min(plans.length - 1, scrollIndex + 1)
                    setScrollIndex(newIndex)
                    scrollToIndex(newIndex)
                  }}
                  disabled={scrollIndex === plans.length - 1}
                />
              </div>
            </>
          )}
        </Card>

        {/* Footer Summary */}
        <div
          className="footer-fixed"
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            background: "#fff",
            borderTop: "1px solid #eee",
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 30px",
            zIndex: 10000,
          }}
        >
          {/* <div>
            <Text>Phí chọn số: </Text>
            <Text strong>{unitPrice}</Text> <br />
            <Text type="secondary">
              <del>210.000</del>
            </Text>
          </div> */}
          <div>
            <Text>Giá SIM: </Text>
            <Text strong>{simPrice.toLocaleString("en-US")}</Text>
          </div>
          <div>
            <Text>Gói cước: </Text>
            <Text strong>
              {(selectedPlan?.price || 0).toLocaleString()} x{" "}
              {selectedDuration + " "}
              tháng =
              {((selectedPlan?.price || 0) * selectedDuration).toLocaleString()}
            </Text>
          </div>
          <div>
            <Text strong style={{ color: "red", fontSize: 18 }}>
              Tổng tiền: {total.toLocaleString("en-US")}
            </Text>
          </div>
          <Button
            type="primary"
            icon={<ShoppingCartOutlined />}
            size="large"
            onClick={handleBuySim}
            loading={loading}
          >
            Thanh toán
          </Button>
        </div>
      </div>
    </MainLayout>
  )
}
